
// import Document from "../components/document/routes";


export const protectedRoutes: any[] = [
    // { path: "/submit-documents", element: Document }
];
